import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { SEND_TEST_EMAIL_DELIVERY } from '../actions/actionTypes';
import {
  sendTestEmailDeliveryDone,
  sendTestEmailDeliveryError,
  sendTestEmailDeliveryLoading,
  sendTestEmailDeliverySuccess
} from '../actions/emailDelivery';
import { adminApi } from '../api/AdminApi';

// Create your Saga here...

export function* watchSendTestEmailDeliverySaga () {
  yield takeLatest(SEND_TEST_EMAIL_DELIVERY, sendTestEmailDeliverySaga);
}

export function* sendTestEmailDeliverySaga ({ tenantId, emails }) {
  try {
    yield put(sendTestEmailDeliveryLoading());
    const result = yield call(adminApi.sendTestEmails, tenantId, emails);
    yield put(sendTestEmailDeliverySuccess(result));
  } catch (error) {
    yield put(sendTestEmailDeliveryError(error));
  } finally {
    yield put(sendTestEmailDeliveryDone());
  }
}

export default [
  fork(watchSendTestEmailDeliverySaga)
];
